import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'p-error-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './p-error-notification.component.html',
  styleUrl: './p-error-notification.component.scss',
})
export class PErrorNotificationComponent {
  @Input() visible = false;
  @Input() message: string | null = '';
  @Input() status?: number | null = null;
  @Input() closable = true;
  @Input() showStatus = false;

  @Output() notificationClick = new EventEmitter<void>();

  onClick(): void {
    if (this.closable) {
      this.notificationClick.emit();
    }
  }
}
